import Component from '@glimmer/component';

interface CircleNumberSignature {
  Args: {
    fillColor?: string;
    number: number;
  };
  Element: SVGSVGElement;
}

export default class CircleNumber extends Component<CircleNumberSignature> {
  get fillColor(): string {
    return this.args.fillColor || '#EF3934';
  }

  <template>
    <svg class="inline-block align-middle" width="18" height="18" viewBox="0 0 18 18" ...attributes>
      <g fill="none" fill-rule="evenodd">
        <circle cx="9" cy="9" r="9" fill={{this.fillColor}} />
        <text fill="#FFF" font-size="12" class="font-sans font-bold">
          <tspan data-test-number x="6.5" y="13">{{@number}}</tspan>
        </text>
      </g>
    </svg>
  </template>
}
